module.exports = __webpack_public_path__ + "img/dMail.2bc93203.svg";